import type { TMissingOfficeInfoField } from '~/domain/OfficeMissingInfo';
import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestMissingInfoPayload {
  /** Reduced profession code: RDH, DA, DN or FD. */
  professionType: string;
  /** The office-profile fields the modal asked for, in display order. */
  missingFields: TMissingOfficeInfoField[];
}

/**
 * Fires each time the required "missing office details" modal opens in the shift request
 * wizard (GOTU-12579). `funnelEntryId` is attached automatically — see `funnelRegistry`.
 * Event: dental_portal:missing_info_popup:viewed
 */
export function fireShiftRequestMissingInfoPopupViewed(
  payload: IShiftRequestMissingInfoPayload,
): void {
  PosthogService.getInstance().track('dental_portal:missing_info_popup:viewed', {
    profession_type: payload.professionType,
    missing_fields: payload.missingFields,
  });
}
